import { BuilderContent } from '@builder.io/react'
import type { BuilderContent as Content } from '@builder.io/sdk'

import { Footer, type FooterModel } from '@/legacy/components/Footer'
import { BUILDER_FOOTER_MODEL } from '@/legacy/config/builder'

interface FooterProps {
  content?: Content
}

const FooterBlock = ({ content }: FooterProps) => (
  <BuilderContent model={BUILDER_FOOTER_MODEL} content={content} options={{ includeRefs: true }}>
    {(footerModel: FooterModel, loading) => {
      if (loading && !footerModel) return null
      return <Footer {...footerModel} />
    }}
  </BuilderContent>
)

export default FooterBlock
